<template>    
   
     
            <h1 class="page-title">{{ $t("catalogue.codes.title") }}</h1>


      
            <div class="flex justify-end">
                <router-link 
                    class="importLink"
                    to="/admin/catalogue/code/create"
                >Importer des codes</router-link>
            </div>
       

       
            <DataNavList :tabs="codeListingTabs" />
       
    
</template>

<script setup lang="ts">
import StockCodeList from "@/components/product/code/StockCodeList.vue"
import StockCodeAvailableList from "@/components/product/code/StockCodeAvailableList.vue"
import StockCodeNotAvailableList from "@/components/product/code/StockCodeNotAvailableList.vue"
import AdminPageLayout from '@/layouts/default/admin/AdminPageLayout.vue';
import DataNavList from '@/components/utility/DataNavList.vue';
import { ListingTabs } from '@/models/utility/ListingTabs';

const codeListingTabs: ListingTabs = {
    available: {
        label: "Disponibles",
        component: StockCodeAvailableList
    },
    notAvailable: {
        label: "Non disponibles",
        component: StockCodeNotAvailableList
    },
    stock: {
        label: "Stock de codes",
        component: StockCodeList
    },
};
</script>

<style scoped>
.importLink {
    @apply ml-auto inline-flex items-center justify-center rounded-full py-2 px-4 text-sm font-semibold 
        focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 bg-blue-600 text-white
        hover:text-slate-100 hover:bg-blue-500 active:bg-blue-800 active:text-blue-100 focus-visible:outline-blue-600;
}
</style>